import styled from 'styled-components'
import { ReactComponent as ChevronVertical } from 'icons/chevron-vertical-16.svg'

const DropdownChevron = styled(ChevronVertical).attrs({
  role: 'img',
})`
  width: 16px;
  height: 16px;
`

export default DropdownChevron
